import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubNavSharedModule, NavDropdownSharedModule } from './../../../patterns/molecules/entry';

import { IconSharedModule } from '../../atoms/icon/icon.module';
import { SubHeaderSharedComponent } from './sub-section.component';

@NgModule({
    declarations: [
        SubHeaderSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        SubNavSharedModule,
        NavDropdownSharedModule
    ],
    exports: [
        SubHeaderSharedComponent
    ]
})
export class SubSectionSharedModule {}
